import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab } from 'material-ui/Tabs'
import SwipeableViews from 'react-swipeable-views'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as CurrentActions from '../../state/actions/current'
import * as ConvoMsgActions from '../../state/actions/conversations-messages'
import ConversationsList from './ConversationsList'
import styles from './styles/ConversationsContainer'
import './styles/tabs.css'

class ConversationsContainer extends Component {
  static propTypes = {
    activeConvosCount: PropTypes.number.isRequired,
    allConvosCount: PropTypes.number.isRequired,
    chooseCurrentConversation: PropTypes.func.isRequired,
    emailOnly: PropTypes.bool.isRequired,
    getMessagesForConversation: PropTypes.func.isRequired,
    handleConvoClick: PropTypes.func.isRequired,
    handleSlide: PropTypes.func.isRequired,
    handleTextUnknownClick: PropTypes.func.isRequired,
    isBlastMsg: PropTypes.bool.isRequired,
    isCurrConversationEmail: PropTypes.func.isRequired,
    selectedConversationId: PropTypes.number,
    convoTabIndex: PropTypes.number.isRequired,
  }

  componentWillReceiveProps = nextProps => {
    const {
      activeConvosCount,
      allConvosCount,
      handleSlide,
      convoTabIndex,
      selectedConversationId,
    } = this.props

    // TODO: also check that it's the first time yr rendering this page...
    if (nextProps.isBlastMsg) {
      if (convoTabIndex !== 0) handleSlide(0)
      return
    }
    // are you receiving conversations from API for the first time?
    // are there also *no* active conversations in this API response?
    if (
      nextProps.allConvosCount > 0 &&
      nextProps.activeConvosCount === 0 &&
      allConvosCount === 0 &&
      activeConvosCount === 0
    ) {
      if (convoTabIndex !== 1) {
        handleSlide(1, selectedConversationId !== -1)
      }
    }
  }

  render() {
    const {
      convoTabIndex,
      emailOnly,
      handleSlide,
      handleTextUnknownClick,
      queryParams,
      height,
      selectedConversationId,
      handleConvoClick,
    } = this.props

    return (
      <div className="Threads" style={styles.threads}>
        <Tabs
          className="ThreadTabs"
          onChange={handleSlide}
          value={convoTabIndex}
          style={styles.tabs}
          tabItemContainerStyle={styles.tabsContainer}
        >
          <Tab
            className="ThreadTab"
            style={styles.tab}
            label="Inbox"
            value={0}
          />
          <Tab
            className="ThreadTab"
            style={styles.tab}
            label="Archive"
            value={1}
          />
        </Tabs>
        <SwipeableViews
          className="ThreadSwipableView"
          index={convoTabIndex}
          value={handleSlide}
          style={styles.swipableThreads}
        >
          <ConversationsList
            className="ConversationsList"
            height={height}
            selectedConversationId={selectedConversationId}
            convoType="activeConvos"
            emailOnly={emailOnly}
            handleConvoClick={handleConvoClick}
            handleTextUnknownClick={handleTextUnknownClick}
            queryParams={queryParams}
          />
          <ConversationsList
            className="ConversationsList"
            height={height}
            selectedConversationId={selectedConversationId}
            convoType="allConvos"
            emailOnly={emailOnly}
            handleConvoClick={handleConvoClick}
            handleTextUnknownClick={handleTextUnknownClick}
            queryParams={queryParams}
          />
        </SwipeableViews>
      </div>
    )
  }
}

const mapStateToProps = ({
  current: {
    conversation: { id: selectedConversationId, isBlastMsg },
  },
  conversations: { activeConvos, allConvos },
}) => ({
  activeConvosCount: activeConvos.idsList.size,
  allConvosCount: allConvos.idsList.size,
  isBlastMsg,
  selectedConversationId,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...CurrentActions,
      ...ConvoMsgActions,
    },
    dispatch,
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConversationsContainer)



// WEBPACK FOOTER //
// ./src/components/Messages/ConversationsContainer.js